// src/pages/auth/ProfileSetup.jsx
import { useForm } from 'react-hook-form'
import { useAuth } from '../../context/AuthContext'
import { useNotification } from '../../context/NotificationContext'
import { useNavigate } from 'react-router-dom'
import client from '../../api/client'
import { Button, TextField, MenuItem, Box, Typography } from '@mui/material'

const GENDERS = ['Male', 'Female']
const EDUCATION_LEVELS = ['High School', 'Bachelor', 'Master', 'PhD', 'Other']

function ProfileSetup() {
 const { user } = useAuth()
 const { add } = useNotification()
 const navigate = useNavigate()
 const { register, handleSubmit, formState: { errors } } = useForm()

 const onSubmit = async (data) => {
 try {
 await client.post('/user/profile', data)
 add('Profile completed! Welcome aboard.', 'success')
 const role = user?.role?.toLowerCase()
 navigate(`/${role}/dashboard`)
 } catch (err) {
 add(err.response?.data?.message || 'Failed to save profile', 'error')
 }
 }

 return (
 <Box className="min-h-screen from-blue-50 to-indigo-100 flex items-center justify-center p-4">
 <Box className=" rounded-2xl shadow-xl p-8 max-w-2xl w-full">
 <Typography variant="h4" className="font-bold text-center mb-2 text-foreground/80">
 Complete Your Profile
 </Typography>

 <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
 {/* Full Name */}
 <TextField
 fullWidth
 label="Full Name"
 {...register('fullName', { required: 'Name is required' })}
 error={!!errors.fullName}
 helperText={errors.fullName?.message}
 />

 {/* Gender */}
 <TextField
 select
 fullWidth
 label="Gender"
 {...register('gender', { required: 'Select gender' })}
 error={!!errors.gender}
 helperText={errors.gender?.message}
 >
 {GENDERS.map((g) => (
 <MenuItem key={g} value={g}>{g}</MenuItem>
 ))}
 </TextField>

 {/* Education */}
 <TextField
 select
 fullWidth
 label="Highest Education"
 {...register('education', { required: 'Select education' })}
 error={!!errors.education}
 helperText={errors.education?.message}
 >
 {EDUCATION_LEVELS.map((e) => (
 <MenuItem key={e} value={e}>{e}</MenuItem>
 ))}
 </TextField>

 {/* Skills */}
 <TextField
 fullWidth
 label="Skills (comma-separated)"
 placeholder="React, Node.js, Python"
 {...register('skills')}
 />

 {/* Resume Upload */}
 <Box>
 <Typography variant="subtitle2" className="mb-2">Upload Resume (PDF)</Typography>
 <input
 type="file"
 accept=".pdf"
 {...register('resume')}
 className="block w-full text-sm text-muted-foreground file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-500/10 file:text-blue-700 hover:file:bg-blue-100"
 />
 </Box>

 {/* Submit */}
 <Button
 type="submit"
 variant="contained"
 size="large"
 fullWidth
 className="mt-6 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
 >
 Save & Continue
 </Button>
 </form>
 </Box>
 </Box>
 )
}

export default ProfileSetup